// General
import "./whats-new-dialog.scss";
import { useEffect, forwardRef } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateWhatsNewDialog } from "../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog, Slide } from "@mui/material";

const WhatsNewDialog = () => {
  // Redux variables
  const whatsNewDialog = useSelector((state) => state.dialog.whatsNewDialog);
  const dispatch = useDispatch();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!whatsNewDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-WhatsNew-Dialog",
      },
    });
  }, [whatsNewDialog]);

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateWhatsNewDialog(false));
  };

  return (
    <Dialog
      fullScreen
      open={whatsNewDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <div id="whats-new-dialog"></div>
    </Dialog>
  );
};

export default WhatsNewDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
